<template>
    <Head title="QM - Criar encomenda" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-4xl text-white leading-tight lobster">
                Criar encomenda
            </h2>
        </template>

        <div class="py-2 flex flex-wrap justify-center">
            <div class="w-11/12 sm:px-6 lg:px-8">

                        <div id="app">
                            <order-form :article_codes="article_codes" :site_url="site_url" />
                        </div>

            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import { Head } from '@inertiajs/inertia-vue3';
import OrderForm from '@/Components/Order/OrderForm.vue';

export default {
    components: {
        OrderForm,
        BreezeAuthenticatedLayout,
        Head,
    },

    props: {
        orderLine: Array,
        site_url: String,
        article_codes: Object
    },

    setup(props) {
    }
}
</script>
